import { render, staticRenderFns } from "./orderGrabbing.vue?vue&type=template&id=19924ad7&scoped=true&"
import script from "./orderGrabbing.vue?vue&type=script&lang=js&"
export * from "./orderGrabbing.vue?vue&type=script&lang=js&"
import style0 from "./orderGrabbing.vue?vue&type=style&index=0&id=19924ad7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19924ad7",
  null
  
)

export default component.exports